module.exports = __webpack_public_path__ + "img/02_sub_no.e673a9a2.svg";